<template>
	<div class="animate__animated animate__fadeIn">
		<h4 class="font-weight-bold">
			Forma de ingresso na unidade e motivo do primeiro atendimento
		</h4>
		<form @submit.prevent="submit" ref="addItem">
			<div class="row mt-3">
				<form-select
					v-model="ingresso.forma"
					grid="12"
					label="De que forma a família (ou membro da família) acessou a Unidade para o primeiro atendimento?"
					:itens="$root.arrays.forma_ingresso"
					:required="true"
				/>

				<form-input
					v-model="ingresso.nome_unidade_origem"
					grid="6"
					label="Nome da unidade/órgão de origem"
					:required="true"
				/>

				<form-input
					v-model="ingresso.nome_contato_unidade_origem"
					grid="6"
					label="Contato do órgão/unidade"
					:required="true"
				/>

				<form-textarea
					v-model="ingresso.descricao_ingresso"
					grid="12"
					label="Quais as razões, demandas ou necessidades que motivaram o primeiro atendimento?"
					:required="true"
				/>
			</div>
			<div class="row mt-3">
				<form-select
					v-model="ingresso.beneficiaria_programa_ingresso"
					label="Assinale abaixo caso a família seja beneficiária, ou algum de seus membros, de pelo menos um dos seguintes programas sociais:"
					:itens="$root.arrays.programas"
					:multiple="true"
				/>
			</div>

			<div class="row mt-3">
				<form-input
					v-model="ingresso.nome_programa_ingresso"
					label="Nome do programa prioritário"
				/>
			</div>
			<div class="row pt-4 px-2 d-flex justify-content-end">
				<button class="btn btn-success btn-submit" data-style="zoom-in" @click="submit">
					<i class="mdi mdi-content-save" />
					{{ $t("Salvar") }}
				</button>
			</div>
		</form>
	</div>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return {
			loading: false,
			ingresso: {},
		};
	},
	mounted() {
		if (this.item.ingresso != null) {
			this.ingresso = this.item.ingresso;
		}
	},
	methods: {
		submit() {
			this.item.ingresso = this.ingresso;
			this.$emit("submit");
		},
	},
};
</script>




